import Tooltip from "../../../../components/tooltip";
import SimulationOptimisation from "./GnaOptimalUtilisation/SimulationCurrentOptimisation";
import SimulationHeader from "./SimulationHeader";
import { useState } from "react";
import MainHeader from "../DateSession";
import { ErrorPopup } from "../../../../components/ErrorHandling";
import BlockRangeSelector from "../../../../components/BlockRangeSelector/BlockRangeSelector";
import ToggleTabs from "./ChartTableToggle";
import GnaTgnaOptimalUtilisationAnylysis from "./GnaOptimalUtilisation/GnaUtilisation";
import GnaTgnaSimulatedUtilisationAnylysis from "./GnaSimulatedUtilisation/GnaUtilisation";
import GnaTgnaMetricsAnylysis from "./GnaMetrics/GnaMetrics";
import { SearchBox } from "../../../../components/Search";
import { useSelector } from "react-redux";
import DateRangeSelector from "../DateRange/DateRangeSelector";
const DataTabs = ["Optimal Utilisation","Simulated Utilisation", "Metrics"];
export default function RuvnlOptimisationIndex() {
  const [error, setError] = useState<string | null>(null);
  const [open, setOpen] = useState(true);
  const [refreshKey, setRefreshKey] = useState(0);
  const [selectedBlock, setSelectedBlock] = useState<any[]>([]);
  const [activeTab, setActiveTab] = useState<string>(DataTabs[0]);
  const [uniqueTargetDate, setUniqueTargetDate] = useState<any[]>([]);

  const preSelectedstartDate = useSelector(
    (state: any) => state.OptimizerRuvnlDate.startDate
  );
  const preSelectedendDate = useSelector(
    (state: any) => state.OptimizerRuvnlDate.endDate
  );
  const [selectedTargetDate, setSelectedTargetDate] = useState<
    Array<{ value: string; label: string; isFixed: boolean }>
  >([]);

  const handleDateChange = (
    start: Date | null,
    end: Date | null,
    allDates: Array<{ value: string; label: string; isFixed: boolean }>
  ) => {
    setSelectedTargetDate(allDates);
  };
  return (
    <>
      <div className="w-full">
        <MainHeader />
        <div className="tabContent">
        <div className="h-[calc(-85px+100vh)] p-4">
          <div className="w-full h-full flex flex-col gap-4">
            <SimulationHeader
              title="GNA Optimisation"
              refreshKey={refreshKey}
              setRefreshKey={setRefreshKey}
            />
            <div className=" flex flex-row gap-4 relative">
              <SimulationOptimisation
                open={open}
                setOpen={setOpen}
                setError={setError}
                refreshKey={refreshKey}
                setRefreshKey={setRefreshKey}
              />

              <div
                className=" gas-chart-container !p-2 bg-white shadow-[rgba(149,157,165,0.2)_0px_8px_24px] rounded-2xl"
                style={{
                  height: "calc(-195px + 100vh)",
                  width:"100%",
                  // marginLeft: "20%",
                  // filter: open ? "blur(0px)" : "blur(2px)",
                  // position: "relative",
                  // pointerEvents: open ? "auto" : "none",
                  // zIndex: "0",
                }}
              >
                <div className="flex justify-between items-center mb-1 border-b border-[#DFEAF2] pb-2">
                  {" "}
                  <div className="flex items-center gap-3">
                    {activeTab === "Metrics" || (
                      // <BlockRangeSelector
                      //   blocks={Array.from({ length: 96 }, (_, i) => i + 1)}
                      //   placeholder="Select Date Range"
                      //   selectedOptions={selectedBlock.map(
                      //     (item) => item.value
                      //   )}
                      //   setSelectedOptions={setSelectedBlock}
                      // />
                      // <SearchBox
                      //   options={uniqueTargetDate.map((item) => ({
                      //     value: item,
                      //     label: item,
                      //   }))}
                      //   isMany={true}
                      //   placeholder="Select Date"
                      //   selectedOptions={selectedTargetDate}
                      //   onChange={setSelectedTargetDate}
                      // />
                      
                      <DateRangeSelector
                        placeholder="Select Date Range"
                        startDate={preSelectedstartDate}
                        endDate={preSelectedendDate}
                        onDateChange={handleDateChange}
                      />
                    )}
                  </div>
                  <div className="flex gap-x-6 justify-end">
                    <ToggleTabs
                      tabs={DataTabs}
                      activeTab={activeTab}
                      setActiveTab={setActiveTab}
                    />
                  </div>
                </div>
                 {activeTab === "Optimal Utilisation" && (
                  <GnaTgnaOptimalUtilisationAnylysis
                    selectedBlock={selectedBlock}
                    refreshKey={refreshKey}
                    setError={setError}
                    setUniqueTargetDate={setUniqueTargetDate}
                    selectedTargetDate={selectedTargetDate}
                  />
                )}
                {activeTab === "Simulated Utilisation" && (
                  <GnaTgnaSimulatedUtilisationAnylysis
                    selectedBlock={selectedBlock}
                    refreshKey={refreshKey}
                    setError={setError}
                    setUniqueTargetDate={setUniqueTargetDate}
                    selectedTargetDate={selectedTargetDate}
                  />
                )}
               
                {activeTab === "Metrics" && (
                  <GnaTgnaMetricsAnylysis
                    selectedBlock={selectedBlock}
                    refreshKey={refreshKey}
                    setError={setError}
                  />
                )}
              </div>
            </div>
          </div>
        </div>

        <ErrorPopup error={error} onClose={() => setError(null)} />
        <div className="gna-footer-container">
          <div className="grid grid-cols-3 justify-between gap-5 ">
            <Tooltip
              note={
                <p>
                  {/* Default values and variable charges are auto-fetched from
                  system. */}
                </p>
              }
              text=""
            >
              <p className="gna-footer-text">Source</p>
            </Tooltip>
            <p className="gna-footer-text col-span-1 text-center">
              Powered by <strong>GNA Energy</strong>
            </p>
            <strong className="gna-footer-text col-span-1 text-end">
              Beta Version
            </strong>
          </div>
        </div>
      </div>
      </div>
    </>
  );
}
